import React from "react";

import {
  Encounter,
} from "@dndModels";

import { makeStyles } from "@utilities/theme_utilities";

import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import ArchiveButton from "@components/input/buttons/icon_buttons/ArchiveButton";
import FlexBox from "@components/layout/FlexBox";

interface Props {
  encounter: Encounter;
  disabled?: boolean;
  onSelect: () => void;
  onDelete: () => void;
  onArchive: () => void;
}

export default function EncounterCard({ encounter, disabled = false, onSelect, onDelete, onArchive }: Props) {
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        marginBottom: '4px',
      },
    });
  });

  const { classes, cx } = useStyles();

  return (
    <div className="padded">
      <FlexBox direction="column" className={cx(classes.root)}>
        <FlexBox direction="row">
          <FlexBox className="header padded clickable" onClick={onSelect}>
            { encounter.name }
          </FlexBox>
          <FlexBox xs_expand={0}>
            <div style={{ float: "right"}}>
              <ArchiveButton
                no_fab
                disabled={disabled}
                is_archived={encounter.is_archived}
                onClick={onArchive}
              />
              <DeleteButton
                no_fab
                disabled={disabled}
                obj_name={encounter.name}
                onClick={onDelete}
              />
            </div>
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </div>
  );
}
